export const ENTITY_DEBUG_ACTION_TYPE = 'debugEntity';
